import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xwhnqxynhcvrciaucypv.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh3aG5xeHluaGN2cmNpYXVjeXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQxNjg4NjcsImV4cCI6MjA2OTc0NDg2N30.GASvJDKDhvAz9IoW04jC5DsRYKBlQlLgRhLN4AOLrn4'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)